<template>
  <div class="marked">
    <div v-if="showTeam && teamData && teamData.students" class="marked-tab custom-scrollbar">
      <div class="mtb-item" v-for="item in teamData.students" :key="item.studentId">
        <div @click="onChangeStudent(item)" class="mtb-content" :class="{'active': item.studentId == currentStudent.studentId}">
          {{showTemcode(item.tempCode)}}
        </div>
      </div>
    </div>
    <div v-if="currentStudent" class="marked-content custom-scrollbar">
      <LabelCell v-if="currentStudent.examineeName" label="考生姓名：" :content="currentStudent.examineeName"></LabelCell>
      <LabelCell v-if="currentStudent.examTickerNo" label="准考证号：" :content="currentStudent.examTickerNo"></LabelCell>
      <LabelCell v-if="currentStudent.examineeIDNo" label="身份证号：" :content="currentStudent.examineeIDNo"></LabelCell>
      <LabelCell v-if="currentStudent.subjects && currentStudent.subjects.length" label="当前科目：" :content="currentStudent.subjectName"></LabelCell>
      <el-button @click="onShowMarked" :disabled="showText" class="mb-15 mt-5">标记</el-button>
      <template v-if="showText">
        <el-input class="mb-15" type="textarea" placeholder="请输入内容" v-model="textarea" maxlength="30" show-word-limit></el-input>
        <el-row type='flex' justify="end">
          <el-button @click="showText = false">取消</el-button>
          <el-button @click="onHandleMark" type="primary">确定</el-button>
        </el-row>
      </template>
    </div>
  </div>
</template>
<script>
import LabelCell from './components/label-cell.vue'
export default {
  name: 'examinee',
  components: { LabelCell },
  data() {
    return {
      textarea: '',
      currentStudent: null,
      streamData: null,
      initParam: null,
      showText: false,
      showTeam: false,
      teamData: null,
    }
  },
  async created() {
    this.initConnect()
  },
  methods: {
    initConnect() {
      const _this = this
      if (window.core) {
        console.log(window.core, '123123111')
        const connectStreamInfoShow = function (streamId) {
          console.log(streamId, 'connectStreamInfoShow')
          _this.onHandleStreamxInfoShow(streamId)
        }
        window.core.streamInfoShow.connect(connectStreamInfoShow)
        window.core.examineeWebLoaded(window.location.href)
        this.$once('hook:beforeDestroy', () => {
          // 销毁页面后取消订阅，避免多次订阅
          window.core.streamInfoShow.disconnect(connectStreamInfoShow)
        })
      } else {
        setTimeout(() => {
          _this.initConnect()
        }, 1000)
      }
    },
    async onHandleStreamxInfoShow(streamId) {
      console.log(streamId, 'onHandleStreamxInfoShow')
      this.streamData = await this.getFormatParam(streamId)
      await this.getInitParam(this.streamData)
      this.getExamInfo()
    },
    async getExamInfo() {
      const { roundId, groupId, examByTeam, isTeamSingleRecord } =
        this.initParam
      const { studentOrTeamID, teamId, studentId, examSubjectId, roomId } = this.streamData

      const param = {
        roundId,
        roomId,
        groupId,
        examSubjectId
      }
      if (!examByTeam || (examByTeam && isTeamSingleRecord)) {
        // studentId
        param.studentId = studentId || studentOrTeamID
        this.showTeam = false
        const res = await this.$HTTP.ApiUser.GETstudentexam(param)
        console.log('考生信息====>', res)
        this.textarea = ''
        this.currentStudent = this.onFromatSubject(res)
      }
      if (examByTeam && !isTeamSingleRecord) {
        // teamId
        console.log()
        this.showTeam = true
        param.teamId = teamId || studentOrTeamID
        param.isNeedTeamGrade = true
        const res = await this.$HTTP.ApiUser.GETgradeteam(param)
        console.log('分组考生信息====>', res)
        await this.onStudentExam(res.students[0].studentId)
        this.teamData = res
      }
    },
    async onStudentExam(studentId) {
      const { roundId, groupId } = this.initParam
      const { roomId } = this.streamData
      const param = {
        roundId,
        roomId,
        groupId,
        studentId,
      }
      const res = await this.$HTTP.ApiUser.GETstudentexam(param)
      this.currentStudent = this.onFromatSubject(res)
    },
    onFromatSubject(res) {
      const { subjectId } = this.streamData
      const result = res
      if (result.subjects && result.subjects.length) {
        const arr = result.subjects.filter(v => v.subjectId == subjectId) || []
        result.subjectName = arr[0].subjectName
      }
      return result
    },
    onChangeStudent(item) {
      this.onStudentExam(item.studentId)
    },
    async getInitParam(data) {
      const res = await this.$HTTP.ApiUser.GETMonitorroomsubjectmeta(data)
      if (res) {
        const { roundId, groupId, examByTeam, subjectMeta } = res
        this.initParam = {
          roundId,
          groupId,
          examByTeam,
          isTeamSingleRecord: subjectMeta.isTeamSingleRecord,
        }
      }
    },
    async getFormatParam(streamId = 'examSubjectID_roomID-1_subjectID_seatNumber') {
      // streamId = 'roundID-studentID_roomID-1_subjectID_seatNumber' 旧的流
      const arr = streamId.split('_')
      const res = await this.$HTTP.ApiUser.GETMonitorroomExam({examSubjectId: arr[0]})
      console.log(res, 'res ===>  121212')
      return {
        roundId: res.roundId || '',
        groupId: res.groupId || '',
        studentOrTeamID: res.studentId || res.teamId,
        teamId: res.teamId || '',
        studentId: res.studentId || '',
        subjectId: res.subjectId || arr[2],
        roomId: res.roomId || '',
        seatNumber: arr[3] || '',
        examSubjectId: arr[0]
      }
    },
    onShowMarked() {
      this.showText = !this.showText
    },
    async onHandleMark() {
      if (!this.textarea) {
        return window.core.showTopTip(1, '请输入标记文字！')
      }
      const { roundId } =
        this.initParam
      const { teacherName, monitorCode, teacherCreNumber } =
        this._storage.getStorageSync('monitorData')
      const { subjectId, examSubjectId } = this.streamData
      const { studentId } = this.currentStudent
      const param = {
        examComment: this.textarea,
        examCommentIds: '',
        examFlag: -1,
        examSubjectId: examSubjectId,
        subjectId: subjectId,
        monitorCode: monitorCode,
        monitorIdNo: teacherCreNumber,
        monitorName: teacherName,
        studentId: studentId,
        roundId: roundId,
      }
      try {
        await this.$HTTP.ApiUser.POSTMonitorroomFlag(param)
        this.showText = false
        window.core.showTopTip(1, '标记成功！')
      } catch (error) {
        this.showText = true
        window.core.showTopTip(1, '标记失败，请重试！')
      }
    },
    showTemcode(val) {
      let result = val
      if (val.includes('B')) {
        result = val.replace('B', '蓝')
      }
      if (val.includes('R')) {
        result = val.replace('R', '红')
      }
      return result
    },
  },
}
</script>
<style lang="scss" scoped>
.marked {
  width: 100%;
  height: 100%;
  display: flex;
  background: #fff;
  &-tab {
    width: 80px;
    height: 100%;
    overflow-y: auto;
    overflow-x: none;
    box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.1);
    padding: 10px 0;
    .mtb-item {
      border-bottom: 1px solid #E8E8E8;
      border-top: 1px solid #E8E8E8;
      height: 44px;
      padding: 6px 0;
      cursor: pointer;
    }
    .mtb-item:first-of-type {
      border-top: none;
    }
    .mtb-item:last-of-type {
      border-bottom: none;
    }
    .mtb-content {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
    }
    .mtb-item .active {
      background: #E5F1FF;
    }
  }
  &-content {
    background: url('../assets/img_info.png') no-repeat;
    background-position: right top;
    background-size: 40%;
    flex: 1;
    height: 100%;
    padding: 14px 24px;
    overflow-y: auto;
    overflow-x: none;
  }
}
</style>
